import React, {FC} from "react";
import {InitiatorName, Link, NotificationHeader, NotificationMessage, ProjectTitle} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import {useTranslation} from "react-i18next";
import { getRepBaseByProvider } from "shared/helpers/shopCardContentDisplayUrl";

const declOfNum = (n: number, titles: string[]) => {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[(n % 100 > 4 && n % 100 < 20) ? 2 : cases[(n % 10 < 5) ? n % 10 : 5]];
}

export const NotificationLike: FC<{item: any}> = ({item}) => {

    const {
        notificationTitle,
        initiator: initiatorTop,
        actions,
        mainRow,
        rowCount
    } = item;

    const firstLike = actions[0]?.likeInfo;
    const initiator = firstLike?.initiator;
    const entity = firstLike?.entityInfo;
    const { t } = useTranslation()

    if (!initiator) return null;

    const getCardUrl = () => {
        const service = actions[0]?.service
        const baseUrl = getRepBaseByProvider(service)
        
        return `${baseUrl}/card/${entity?.entityId}`
    }

    const linkProps = entity?.entityType === 'card'
      ? {
          as: 'a' as const,
          href: getCardUrl(),
          target: '_blank',
          onClick: (e: any) => {
              e.preventDefault()
              window.open(getCardUrl(), '_blank')
          },
      }
      : entity?.entityType === 'team'
      ? {
          to: CreateLinkTo.team(entity?.entityId)
      }
      : {
          to: CreateLinkTo.project(entity?.entityId)
      }



    return <NotificationHeader gx={8}>
        <NotificationMessage>
            {firstLike?.isAuthorized ? (
                    <Link to={CreateLinkTo.designer(initiator?.accountId)}>
                        <InitiatorName>
                            {initiatorTop?.displayedName}
                        </InitiatorName>
                    </Link>)
                : (
                    <InitiatorName>
                        {initiatorTop?.displayedName}
                    </InitiatorName>
                )}
            {' '}
            {mainRow && rowCount > 0 ? t(`notifications.row_${declOfNum(rowCount, ['count', 'counts', 'count'])}`, { count: rowCount }) : null}
            {notificationTitle}
            {' '}
            {/*@ts-ignore*/}
            <Link {...linkProps}>
                <ProjectTitle>
                    {entity?.entityTitle}
                </ProjectTitle>
            </Link>
        </NotificationMessage>
    </NotificationHeader>
}import React, {FC} from "react";
import {InitiatorName, Link, NotificationHeader, NotificationMessage, ProjectTitle} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import {useTranslation} from "react-i18next";
import { getRepBaseByProvider } from "shared/helpers/shopCardContentDisplayUrl";

const declOfNum = (n: number, titles: string[]) => {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[(n % 100 > 4 && n % 100 < 20) ? 2 : cases[(n % 10 < 5) ? n % 10 : 5]];
}

export const NotificationLike: FC<{item: any}> = ({item}) => {

    const {
        notificationTitle,
        initiator: initiatorTop,
        actions,
        mainRow,
        rowCount
    } = item;

    const firstLike = actions[0]?.likeInfo;
    const initiator = firstLike?.initiator;
    const entity = firstLike?.entityInfo;
    const { t } = useTranslation()

    if (!initiator) return null;

    const getCardUrl = () => {
        const service = actions[0]?.service
        const baseUrl = getRepBaseByProvider(service)
        
        return `${baseUrl}/card/${entity?.entityId}`
    }

    const linkProps = entity?.entityType === 'card'
      ? {
          as: 'a' as const,
          href: getCardUrl(),
          target: '_blank',
          onClick: (e: any) => {
              e.preventDefault()
              window.open(getCardUrl(), '_blank')
          },
      }
      : entity?.entityType === 'team'
      ? {
          to: CreateLinkTo.team(entity?.entityId)
      }
      : {
          to: CreateLinkTo.project(entity?.entityId)
      }



    return <NotificationHeader gx={8}>
        <NotificationMessage>
            {firstLike?.isAuthorized ? (
                    <Link to={CreateLinkTo.designer(initiator?.accountId)}>
                        <InitiatorName>
                            {initiatorTop?.displayedName}
                        </InitiatorName>
                    </Link>)
                : (
                    <InitiatorName>
                        {initiatorTop?.displayedName}
                    </InitiatorName>
                )}
            {' '}
            {mainRow && rowCount > 0 ? t(`notifications.row_${declOfNum(rowCount, ['count', 'counts', 'count'])}`, { count: rowCount }) : null}
            {notificationTitle}
            {' '}
            {/*@ts-ignore*/}
            <Link {...linkProps}>
                <ProjectTitle>
                    {entity?.entityTitle}
                </ProjectTitle>
            </Link>
        </NotificationMessage>
    </NotificationHeader>
}